import type ModuleButtonsType from 'app/main/modules/components/ModuleButtonsType';
import { showDeleteDialog } from 'app/main/components';
import { showTagsEditDialog } from './TagsEditDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				action: ({ model, dispatch, userData, updateRefresh }) =>
					dispatch(
						showTagsEditDialog({
							baseModel: {
								tags_id: model.tags_id,
								tags_title: model.tags_title,
								tags_user_created_uid: userData.user_uid
							},
							updateRefresh
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'tags'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							id: model.tags_id,
							title: model.tags_title,
							module: 'tags',
							updateRefresh,
							hardDelete: true
						})
					)
			}
		],
		headerButtons: [
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				iconAdd: false,
				action: ({ dispatch, updateRefresh }) => dispatch(showTagsEditDialog({ isAdd: true, updateRefresh }))
			}
		]
	}
};

export default buttons;
